import { Outlet, Navigate } from "react-router-dom"

const CutterRoutes = (props) => {
  return props.cutter ? <Outlet /> : <Navigate to="/login" />
}

export default CutterRoutes
